import * as React from "react"
import {Button, Modal} from "semantic-ui-react"

export interface Props {
  onConfirm: () => void
  onDismiss: () => void
}

export function DeleteCommonPlaceModal(props: Props) {
  const {onConfirm, onDismiss} = props

  return (
    <Modal dimmer="blurring" size="small" open={true} closeOnDimmerClick={false}>
      <Modal.Header>Delete Common Place</Modal.Header>
      <Modal.Content>
        <p>Are you sure you want to delete this common place?</p>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onDismiss}>Return to list</Button>
        <Button negative onClick={onConfirm}>
          Delete Common Place
        </Button>
      </Modal.Actions>
    </Modal>
  )
}



// WEBPACK FOOTER //
// ./src/components/DeleteCommonPlaceModal.tsx